<template>
  <div class="media-wrapper" :class="{playable: isPlayable, fullscreen: isFullScreen}">
    <video v-if="isVideo" :src="getStaticPath('img/temp/test_video.png')"></video>
    <img v-else width="100%" :src="issue.files.figures[$parent.selectedId].optimized_urls.hero">
    <div v-if="isVideo" class="play-button" v-on:click="playVideo($event)" v-bind:style="{backgroundImage: 'url(' + getStaticPath('img/play-circle.png') + ')'}"></div>
    <div class="share-button" v-if="share" v-bind:style="{backgroundImage: 'url(' + getStaticPath('img/share-circle.png') + ')'}"></div>
    <div class="issue-header" v-if="header && !collectionsHeader">
      <div class="articleType">Article Type: <span>{{ issue.article_type.name }}</span></div>
      <div class="title">{{ trimTextToLength(issue.title, 100) }}</div>
    </div>
    <div class="issue-header" v-if="collectionsHeader">
      <div class="articleType" v-html="issue.caption"></div>
      <div class="title">{{ trimTextToLength(issue.title, 100) }}</div>
    </div>
  </div>
</template>

<script>
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  export default {
    name: 'media-player',
    mixins: [ UtilityMixin ],
    props: ['issue', 'header', 'share', 'collectionsHeader'],
    data () {
      return {
        isPlayable: false,
        isFullScreen: false
      }
    },
    mounted () {
      var self = this
      var player = this.$el.querySelector('video')
      if (player) {
        player.onwebkitfullscreenchange = function () {
          self.isFullScreen = this.webkitDisplayingFullscreen
        }
        player.onpause = function () {
          setTimeout(function () {
            if (this.paused) {
              self.isPlayable = false
              this.controls = false
            }
          }.bind(this), 250)
        }
        player.onplay = function () {
          this.controls = true
          self.isPlayable = true
        }
      }
    },
    methods: { // TODO temp method for returm temp issue cover image path, must be removed after use rest service
      playVideo ($event) {
        var player = this.$el.querySelector('video')
        player.play()
      }
    },
    computed: {
      isVideo () {
        // ToDO - add some logic with real services to clarify is it video - or graphic  item
        return this.issue.video_url
      }
    }
  }
</script>


<style lang="scss" scoped>
  .media-wrapper::-webkit-scrollbar {
    width: 5px;
    height: 8px;
    background-color: #aaa
  }
  .media-wrapper::-webkit-scrollbar-thumb {
    background-color: black;
    outline: 1px solid slategrey;
  }

  .media-wrapper {
    max-height: 400px;
    overflow-y: auto;
    margin: auto;
    &.fullscreen {
      display: block;
    }
  }
  video {
    width: 100%;
    max-height: 402px;
  }
  .playable {
    .issue-header {
      display: none;
    }
    .play-button {
      display: none;
    }
    &:hover {
      .controls {
        display: block;
      }
    }
  }
  .controls {
    display: none;
    background-color: $black;
    opacity: 0.7;
    position: absolute;
    width: 100%;
    height: 10%;
    bottom: 0;
    .pause-button {
      background-size: contain;
      width: 5.6%;
      padding-top: 5.6%; /* 1:1 Aspect Ratio */
      position: relative;
      cursor: pointer;
    }
  }
  .issue-header {
    background-color: $primary-color;
    opacity: 0.7;
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    padding: $spacing-large;
    .articleType {
      font-family: 'Merriweather', serif;
      font-size: 14px;
      font-style: italic;
      line-height: 1.21;
      text-align: left;
      color: $white;
      margin-bottom: 12.5px;
      span {
        text-decoration: underline;
      }
    }
    .title {
      font-family: Merriweather;
      font-size: 28.4px;
      font-weight: 300;
      line-height: 1.17;
      text-align: left;
      color: $white;
    }
  }
  .play-button {
    width: 30%;
    height: 30%;
    position: absolute;
    top: 35%;
    right: 35%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }
  .share-button {
    width: 12%;
    height: 12%;
    position: absolute;
    top: 2%;
    right: 1%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }

  @media (max-width: $breakpoint-md) {
    .issue-header {
      padding: 8px 20px;
      .title {
        font-size: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// MediaPlayerComponent.vue?2ffa6b69